import hbscan from "../../api/hbscan";
import Auth from "../auth/AuthService";
import { ITicketDetail } from "../../models/ticket/ticketDetail";

class TicketService {
  async GetTicketsByCompany(): Promise<ITicketDetail[]> {
    return (
      await hbscan.get<ITicketDetail[]>(
        "/api/hbscan/Ticket/GetTicketsByCompany",
        {
          headers: { Authorization: Auth?.user?.guid || "" },
          params: { companyId: Auth?.user?.companyId },
        }
      )
    ).data;
  }

  async GetTicketsByPropertyGroup(propertyGroupId: number): Promise<ITicketDetail[]> {
    return (
      await hbscan.get<ITicketDetail[]>(
        "/api/hbscan/Ticket/GetTicketsByPropertyGroup",
        {
          headers: { Authorization: Auth?.user?.guid || "" },
          params: { propertyGroupId },
        }
      )
    ).data;
  }



  async GetTicketPDF(ticketId: number): Promise<any> {
    return (
      await hbscan.get(
        "/api/hbscan/Ticket/GetTicketPDF",
        {
          headers: { Authorization: Auth?.user?.guid || "" },
          params: { ticketId }
        }
      )
    ).data;
  }
}

const ticketService = new TicketService();

export default ticketService;